import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * AuthCallback handles the return from Google OAuth via Emergent Auth.
 * It extracts the session_id from the URL hash and exchanges it for user data.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserFromGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing (React StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error('Session invalide');
          navigate('/auth');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data via backend
        const response = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId
        });

        const { token, user, first_name } = response.data;

        // Store token and user data
        setUserFromGoogle(token, user);

        toast.success(`Bienvenue ${first_name} ! 🎉`);
        
        // Navigate to dashboard
        navigate('/dashboard', { replace: true });

      } catch (error) {
        console.error('Google auth error:', error);
        toast.error(error.response?.data?.detail || 'Erreur de connexion Google');
        navigate('/auth');
      }
    };

    processGoogleAuth();
  }, [location, navigate, setUserFromGoogle]);

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-nunito text-xl text-charcoal">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
